import { useMemo } from 'react';
import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { Grid, TextInput } from '@ts/storybook';
import { IForm } from '@ts/ui-models';

const ItemInCustodyForm = (props: IForm) => {
  const { values, mode, onCallbackChange } = props;

  const isViewMode = mode === 'view';

  let elementTypeId;
  if (values.elementType != null) elementTypeId = values.elementType.id;
  else elementTypeId = null;

  const searchComponentConfig = useMemo(() => {
    const config = generateSearchEntitySelector('tag');
    return {
      component: config.component,
      configComponent: {
        ...config.configComponent,
        filtersFetchData: {
          restriction: 'tsElement',
          elementTypeId: elementTypeId,
        },
      },
    };
  }, []);

  const onChangeHS = entity => {
    const value = entity ? entity.getID() : null;
    onCallbackChange('hsCode')(entity);
    return onCallbackChange('hsCodeId')(value);
  };

  return (
    <Grid container size={{ xs: 12 }} spacing={2}>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          label="Reason tags"
          value={props.values.selectedReasonTags}
          searchComponent={searchComponentConfig}
          onChange={onCallbackChange('selectedReasonTags')}
          isReadOnly={isViewMode}
          multiple
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          label="Nature tags"
          value={props.values.selectedNatureTags}
          searchComponent={searchComponentConfig}
          onChange={onCallbackChange('selectedNatureTags')}
          isReadOnly={isViewMode}
          multiple
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WrapperEntitySelector
          label="Item type tags"
          value={props.values.selectedItemTypeTags}
          searchComponent={searchComponentConfig}
          onChange={onCallbackChange('selectedItemTypeTags')}
          isReadOnly={isViewMode}
          multiple
        />
      </Grid>
      <Grid container size={{ xs: 12 }}>
        <WrapperEntitySelector
          label={'HS Code'}
          isReadOnly={isViewMode}
          value={values.hsCodeId}
          onChangeEntity={v => onChangeHS(v)}
          searchComponent={generateSearchEntitySelector('hscode')}
        />
        <WrapperEntitySelector
          label={'Currency'}
          searchComponent={generateSearchEntitySelector('currency')}
          isReadOnly={isViewMode}
          value={values.currency}
          onChangeEntity={(currency: any) => {
            const value = currency ? currency.getID() : null;
            onCallbackChange('currency')(currency);
            return onCallbackChange('currencyId')(value);
          }}
        />
        <TextInput
          label="Quantity"
          value={props.values.quantity}
          onChangeValue={onCallbackChange('quantity')}
          isReadOnly={isViewMode}
          type="number"
        />
        <TextInput
          label="Weight"
          value={props.values.weight}
          onChangeValue={onCallbackChange('weight')}
          isReadOnly={isViewMode}
          type="number"
        />
      </Grid>
    </Grid>
  );
};

export default ItemInCustodyForm;
